import app from '../firebase-app'
import { b64DecodeUnicode } from './base64'

const STATE = {
  namespaced: true,

  state () {
    return {
      user: null,
      unsubscribeFn: null
    }
  },

  mutations: {
    USER_UPDATE (state, { user }) {
      state.user = user
    },
    METADATA_CONNECT (state, payload) {
      state.unsubscribeFn = payload
    },
    METADATA_DISCONNECT (state) {
      if (state.unsubscribeFn) {
        state.unsubscribeFn()
        state.unsubscribeFn = null
      }
    }
  },

  actions: {
    fetchMetadata: async ({ commit }, user) => {
      try {
        const token = await user.getIdToken(true)
        const { accountId } = JSON.parse(b64DecodeUnicode(token.split('.')[1]))
        if (!accountId) {
          console.log('[accountId] notfound in token')
          commit('USER_REMOVE', null, { root: true })
          return
        }
        const snapshot = await app.database().ref(`accounts/${accountId}/account`).once('value')
        if (!snapshot.exists()) {
          console.log(`account ${accountId} notfound in db`)
          commit('USER_REMOVE', null, { root: true })
          return
        }
        const account = snapshot.val()
        account['.key'] = accountId
        commit('ACCOUNT_UPDATE', { user, account }, { root: true })
      } catch (e) {
        console.error(e)
        commit('USER_REMOVE', null, { root: true })
      }
    }
  }
}

export default function (store, router, options) {
  const { name = 'claims', route } = (options || {})
  store.registerModule(name, STATE)

  router.beforeEach((to, from, next) => {
    if (to.matched.some(record => record.meta.requiresAuth)) {
      const { authLoading, account } = store.state
      if (authLoading) {
        store.subscribe(({ type, payload }) => {
          if (type === 'USER_REMOVE') {
            next(route(to, from))
          }
          if (type === 'ACCOUNT_UPDATE') {
            next()
          }
        })
      } else if (account) {
        next()
      } else {
        next(route(to, from))
      }
    } else {
      next()
    }
  })

  const unsubscribeFn = app.auth().onAuthStateChanged(user => {
    store.commit(`${name}/METADATA_DISCONNECT`)
    if (user) {
      store.commit(`${name}/USER_UPDATE`, { user })
    } else {
      store.commit('USER_REMOVE')
    }
  })
  store.subscribe(({ type, payload }) => {
    if (type === `${name}/USER_UPDATE`) {
      const { user } = payload
      const userRef = app.database().ref(`metadata/${user.uid}/refreshTime`)
      const callback = userRef.on('value', async snapshot => {
        if (!snapshot.exists()) {
          console.log(`notfound [metadata/${user.uid}/refreshTime]`)
          store.commit('USER_REMOVE')
        } else {
          store.dispatch(`${name}/fetchMetadata`, user)
        }
      })
      store.commit(`${name}/METADATA_CONNECT`, function () {
        userRef.off('value', callback)
      })
    }
    if (type === 'USER_REMOVE') {
      unsubscribeFn()
      store.commit(`${name}/METADATA_DISCONNECT`)
    }
  })
}
